/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: "b987b71c-f857-4bf2-a59e-94b0ee27cefb", //The client id from the app registration
        authority: "https://login.microsoftonline.com/organizations",
        redirectUri: '/',
        logoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        //console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read","https://app.vssps.visualstudio.com/user_impersonation"]
};

/* export const reportRequest = {
    //scopes: ["api://f017e17d-7438-49d2-b68c-5445d30bf8e2/user_impersonation"]
    scopes: ["https://app.vssps.visualstudio.com/user_impersonation"]
};
 */
export const devopsRequest = {
    scopes: ["499b84ac-1321-427f-aa17-267ca6975798/.default"] //this is the scope for the DevOps API
};


/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
    graphOrganizationsEndpoint: "https://graph.microsoft.com/v1.0/organization"
};

export const devopsConfig = {
    listAccounts: "https://app.vssps.visualstudio.com/_apis/accounts?api-version=6.0"
}

